import GroupAddIcon from '@mui/icons-material/GroupAdd';
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const getUsersManagement = () => ({
    id: 'users',
    type: 'group',
    children: [
        {
            id: 'users',
            title: i18n.t('sidemenu.userManagement'),
            type: 'item',
            url: '/users',
            icon: GroupAddIcon,
            breadcrumbs: false,
        },
    ]
});

export default getUsersManagement;